/** 各フェーズ定義 */
export const PHASE = {
  STANDBY: 'standby',
  EXECUTION: 'execution',
  SUCCESS: 'success',
  FAILED: 'failed'
};